import React from 'react';
import POROperationBadge from '../../PortOpeningRequests/components/POROperationBadge';

interface DNDROperationBadgeProps {
	children: string;
}

const DNDROperationBadge = ({ children }: DNDROperationBadgeProps) => (
	<POROperationBadge>{children}</POROperationBadge>
);

export default DNDROperationBadge;